import type { Client } from 'types';

export interface BdoStatementDefaults {
	wasteCode: string | undefined;
	wasteName: string | undefined;
	pickupAddress: string | undefined;
	companyName: string | undefined;
	registeredAddress: string | undefined;
	nipPesel: string | undefined;
	signedPlace: string | undefined;
}

// Waste codes (katalog odpadów) for the waste types suggested when creating an order.
const WASTE_CODES: Record<string, string> = {
	mieszany: '17 09 04',
	gruz: '17 01 07',
	drewno: '17 02 01',
	styropian: '17 06 04',
	papa: '17 03 80',
};

const nonBlank = (value: string | null | undefined) => value?.trim() || undefined;

// Suggested statement values, taken from the client and the order. Legacy classic orders may lack
// a waste type or address, and the client may still be loading, so every default is optional.
export const getBdoStatementDefaults = (
	client: Client | undefined,
	order: { address: string | null; wasteType: string | null }
): BdoStatementDefaults => {
	const wasteName = nonBlank(order.wasteType);
	const postalAndCity = [nonBlank(client?.postal), nonBlank(client?.city)].filter(Boolean).join(' ');

	return {
		wasteCode: wasteName && WASTE_CODES[wasteName.toLocaleLowerCase()],
		wasteName,
		pickupAddress: nonBlank(order.address),
		companyName: nonBlank(client?.name),
		registeredAddress: [nonBlank(client?.street), postalAndCity].filter(Boolean).join(', ') || undefined,
		nipPesel: nonBlank(client?.nip),
		signedPlace: nonBlank(client?.city),
	};
};
